export const LS_KEY_ACCESS_TOKEN = 'CARBCOIN_ACCESS_TOKEN';
export const LS_KEY_REFRESH_TOKEN = 'CARBCOIN_REFRESH_TOKEN';
export const LS_KEY_USER_PROFILE = 'CARBCOIN_USER_PROFILE';
export const LS_KEY_WALLET_STATE = 'CARBCOIN_WALLET_STATE';
